import { ReactNode } from 'react';

import { cx } from '@libs/classnames';
import { PhoenixRoundLogo } from '@ui/components/logos/PhoenixRoundLogo/PhoenixRoundLogo';

import styles from './ExternalAuthButton.module.css';

type Props = {
  className?: string;
  provider: 'chessopen' | 'chessopenProfile';
  disabled?: boolean;
  onClick?: () => void;
};

const PRESETS: Record<Props['provider'], { label: string; icon: ReactNode }> = {
  chessopen: {
    label: 'Войти через ChessOpen ID',
    icon: <PhoenixRoundLogo preset="custom" />,
  },
  chessopenProfile: {
    label: 'Русская Шахматная Школа',
    icon: <PhoenixRoundLogo preset="custom" />,
  },
};

export function ExternalAuthButton({ className, provider, disabled, onClick }: Props) {
  const { label, icon } = PRESETS[provider];
  return (
    <button
      type="button"
      className={cx(styles.authButton, className)}
      disabled={disabled}
      onClick={onClick}
    >
      <div>{label}</div>
      <div className={styles.icon}>{icon}</div>
    </button>
  );
}
